import '../css'

$(function() {
  if ($('#error_explanation').length > 0 && $('article#application').length > 0) {
    location.href = '#application'
  }
})
